import MainArea from './main-area';

export default MainArea;